package com.macrofocus.eflux.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.network.SubstationNetwork
import com.macrofocus.eflux.ui.PaletteType
import com.macrofocus.eflux.ui.data.risk.*
import i18next.useTranslation
import mui.material.Box
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.sx
import org.mkui.react.useProperty
import react.FC
import react.PropsWithChildren
import react.ReactNode
import web.cssom.Display
import web.cssom.FlexWrap
import web.cssom.JustifyContent
import web.cssom.px

external interface RiskInfoProps : PropsWithChildren {
    var network: SubstationNetwork?
    var riskMask: MutableProperty<Int>
}

val RiskInfo = FC<RiskInfoProps> { props ->
    val theme = useTheme<Theme>()
    val paletteType = if (theme.asDynamic().palette.mode == "dark") PaletteType.dark else PaletteType.light
    val (t, _) = useTranslation()

    val network = props.network

    val (riskFilter, setRiskFilter) = useProperty(props.riskMask)

    if (network != null) {
        var lightning_hit = 0
        var lightning_activity = 0
        var lightning_expected = 0
        var flooding = 0
        var mudslide = 0
        var wind_gusts = 0
        var temperature = 0

        for (line in network.links) {
            line.riskMap?.let {
                if (it and LightningHitBit != 0) lightning_hit++
                if (it and LightningActivityBit != 0) lightning_activity++
                if (it and LightningExpectedBit != 0) lightning_expected++
                if (it and FloodingBit != 0) flooding++
                if (it and MudslideBit != 0) mudslide++
                if (it and WindGustsBit != 0) wind_gusts++
                if (it and TemperatureBit != 0) temperature++
            }
        }

        Box {
            sx {
                display = Display.flex
                flexWrap = FlexWrap.nowrap
                gap = 10.px
                marginTop = 16.px
                justifyContent = JustifyContent.center
            }

            TemperatureBadge {
                if (temperature > 0) {
                    badgeContent = ReactNode(temperature.toString())
                    disabled = riskFilter and TemperatureBit == 0
                    onClick = { setRiskFilter(riskFilter xor TemperatureBit) }
                }
            }

            WindGustsBadge {
                if (wind_gusts > 0) {
                    badgeContent = ReactNode(wind_gusts.toString())
                    disabled = riskFilter and WindGustsBit == 0
                    onClick = { setRiskFilter(riskFilter xor WindGustsBit) }
                }
            }

            MudslideBadge {
                if (mudslide > 0) {
                    badgeContent = ReactNode(mudslide.toString())
                    disabled = riskFilter and MudslideBit == 0
                    onClick = { setRiskFilter(riskFilter xor MudslideBit) }
                }
            }

            FloodingBadge {
                if (flooding > 0) {
                    badgeContent = ReactNode(flooding.toString())
                    disabled = riskFilter and FloodingBit == 0
                    onClick = { setRiskFilter(riskFilter xor FloodingBit) }
                }
            }

            LightningHitBadge {
                if (lightning_hit > 0) {
                    badgeContent = ReactNode(lightning_hit.toString())
                    disabled = riskFilter and LightningHitBit == 0
                    onClick = { setRiskFilter(riskFilter xor LightningHitBit) }
                }
            }

            LightningExpectedBadge {
                if (lightning_expected > 0) {
                    badgeContent = ReactNode(lightning_expected.toString())
                    disabled = riskFilter and LightningExpectedBit == 0
                    onClick = { setRiskFilter(riskFilter xor LightningExpectedBit) }
                }
            }

            LightningActivityBadge {
                if (lightning_activity > 0) {
                    badgeContent = ReactNode(lightning_activity.toString())
                    disabled = riskFilter and LightningActivityBit == 0
                    onClick = { setRiskFilter(riskFilter xor LightningActivityBit) }
                }
            }
        }
    }
}